import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AppService } from '../../app.service';

/**
 * Mirrors the AngularJS `access: 4` check on admin states.
 * Redirects to /accessDenied when the user's system_access_level is too low.
 */
@Injectable({ providedIn: 'root' })
export class AdminGuard  {
  constructor(private appService: AppService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): boolean {
    const requiredLevel = route.data?.['accessLevel'] ?? 4;
    const userLevel = this.appService.USER_SETTINGS?.user?.system_access_level ?? 0;

    if (userLevel >= requiredLevel) {
      return true;
    }

    this.router.navigate(['/accessDenied']);
    return false;
  }
}
